export const features = Object.values(
  // prettier-ignore
  import.meta.glob("./features/*", {
    eager: true,
  }) as {
/* GENERATED */ "./features/activities.ts": typeof import("./features/activities.ts"),
/* GENERATED */ "./features/bookables.ts": typeof import("./features/bookables.ts"),
/* GENERATED */ "./features/bookingCheckout.ts": typeof import("./features/bookingCheckout.ts"),
/* GENERATED */ "./features/bookings.ts": typeof import("./features/bookings.ts"),
/* GENERATED */ "./features/branches.ts": typeof import("./features/branches.ts"),
/* GENERATED */ "./features/customers.ts": typeof import("./features/customers.ts"),
/* GENERATED */ "./features/emailSends.ts": typeof import("./features/emailSends.ts"),
/* GENERATED */ "./features/emailTemplates.ts": typeof import("./features/emailTemplates.ts"),
/* GENERATED */ "./features/membershipCheckout.ts": typeof import("./features/membershipCheckout.ts"),
/* GENERATED */ "./features/memberships.ts": typeof import("./features/memberships.ts"),
/* GENERATED */ "./features/metrics.ts": typeof import("./features/metrics.ts"),
/* GENERATED */ "./features/organizations.ts": typeof import("./features/organizations.ts"),
/* GENERATED */ "./features/paymentMethods.ts": typeof import("./features/paymentMethods.ts"),
/* GENERATED */ "./features/pointOfSale.ts": typeof import("./features/pointOfSale.ts"),
/* GENERATED */ "./features/posCheckout.ts": typeof import("./features/posCheckout.ts"),
/* GENERATED */ "./features/products.ts": typeof import("./features/products.ts"),
/* GENERATED */ "./features/promotions.ts": typeof import("./features/promotions.ts"),
/* GENERATED */ "./features/recurrences.ts": typeof import("./features/recurrences.ts"),
/* GENERATED */ "./features/staffs.ts": typeof import("./features/staffs.ts"),
/* GENERATED */ "./features/user.ts": typeof import("./features/user.ts"),
/* GENERATED */ "./features/waivers.ts": typeof import("./features/waivers.ts")
},
);
